import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface cmsState {
	isLoading: boolean;
	cmsList: any;
	cmsDetail: any;
	enDetail: any;
	arDetail: any;
	cmsType: number;
}

const initialState: cmsState = {
	isLoading: false,
	cmsList: [],
	cmsDetail: {},
	enDetail: {},
	arDetail: {},
	cmsType: 0
};

const cmsSlice = createSlice({
	name: 'cmsSlice',
	initialState,
	reducers: {
		getAllCmsListInIt: state => {
			state.isLoading = true;
		},
		getAllCmsListSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			const data = action.payload.data;
			state.cmsList = [...data.cmsList];
		},
		getAllCmsListError: state => {
			state.isLoading = false;
		},
		editcmsDetailInIt: state => {
			state.isLoading = true;
		},
		editcmsDetailSuccess: state => {
			state.isLoading = false;
		},
		editcmsDetailError: state => {
			state.isLoading = false;
		},
		getcmsTamplteByIdInIt: state => {
			state.isLoading = true;
			state.enDetail = '';
			state.arDetail = '';
			state.arDetail = {};
			state.enDetail = {};
			state.cmsType = 0;
		},
		getcmsTamplteByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.cmsDetail = { ...(action.payload.data.cmsList || {}) };
			const Detail = { ...(action.payload.data.cmsList || {}) };
			const enDetail =
				Detail?.cmsTranslations?.find(
					(data: any) => data?.language?.languageCode == 'en'
				) || {};
			const arDetail =
				Detail?.cmsTranslations?.find(
					(data: any) => data?.language?.languageCode == 'ar'
				) || {};
			// console.log(enDetail);
			state.arDetail = arDetail;
			state.enDetail = enDetail;
			state.cmsType = action.payload?.data?.cmsList?.key;
		},
		getcmsTamplteByIdError: state => {
			state.isLoading = false;
			state.enDetail = '';
			state.arDetail = '';
			state.arDetail = {};
			state.enDetail = {};
			state.cmsType = 0;
		}
	}
});

export const {
	getAllCmsListError,
	getAllCmsListInIt,
	getAllCmsListSuccess,
	editcmsDetailError,
	editcmsDetailInIt,
	editcmsDetailSuccess,
	getcmsTamplteByIdError,
	getcmsTamplteByIdInIt,
	getcmsTamplteByIdSuccess
} = cmsSlice.actions;

export default cmsSlice.reducer;
